import React, { useEffect, useState } from 'react';
import ParticleBackground from './ParticleBackground';
import TorusKnot from './TorusKnot';
import './Hero.css';

const PHRASES = [
  'Web Developer',
  'UI Developer',
  'Responsive App Developer',
  'Blockchain Enthusiast',
];

function useTypewriter(phrases) {
  const [text, setText] = useState('');
  const [phraseIdx, setPhraseIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const phrase = phrases[phraseIdx];
    let timeout;

    if (!deleting) {
      if (charIdx < phrase.length) {
        timeout = setTimeout(() => setCharIdx(c => c + 1), 80);
      } else {
        timeout = setTimeout(() => setDeleting(true), 1800);
      }
    } else {
      if (charIdx > 0) {
        timeout = setTimeout(() => setCharIdx(c => c - 1), 40);
      } else {
        setDeleting(false);
        setPhraseIdx(p => (p + 1) % phrases.length);
      }
    }

    setText('> ' + phrase.slice(0, charIdx) + '_');
    return () => clearTimeout(timeout);
  }, [charIdx, deleting, phraseIdx, phrases]);

  return text;
}

function Hero() {
  const typed = useTypewriter(PHRASES);

  return (
    <section id="hero" className="hero-section">
      <ParticleBackground />

      {/* 3D canvas right side */}
      <div className="hero-3d">
        <TorusKnot />
      </div>

      {/* Content */}
      <div className="hero-content">
        <p className="hero-eyebrow">Software Engineer · FrontEnd Developer · Blockchain</p>
        <h1 className="hero-name">JAYDEEP<br />KAUSHIK</h1>
        <p className="hero-subtitle">Building elegant, scalable digital experiences</p>
        <div className="hero-typewriter">{typed}</div>
        <div className="hero-cta">
          <button className="btn-primary" onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}>
            View Work
          </button>
          <button className="btn-outline" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
            Get In Touch
          </button>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-line" />
        <span className="scroll-text">Scroll</span>
      </div>
    </section>
  );
}

export default Hero;
